import {
  Backdrop,
  Box,
  CircularProgress,
  Drawer,
  Grid2,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { colors } from "../../theme/theme";
import { SecondaryBtn } from "./CustomBtn";
import {
  Close,
  East,
  EmailOutlined,
  PersonOutline,
  Today,
} from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { CustomInputLabel } from "../Creators/CustomInputLabel";
import { CustomInput } from "./CustomInput";
import {
  getAllPosts,
  subscribeToContent,
} from "../../redux/actions/posts.dispatcher";
import { ErrorSnackbar } from "./CustomSnackbar";
import { getSubscriptionOfUser } from "../../redux/actions/subscriptions.dispatcher";
import {
  getAllCreators,
  getCreatorsSubscribed,
  getUserById,
  subscribeCreator,
} from "../../redux/actions/user.dispatcher";
import { useNavigate } from "react-router-dom";

import {
  CardElement,
  useElements,
  useStripe,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from "@stripe/react-stripe-js";
import axiosInstance from "../../utils/config/config";

const SubscribeVideoDrawer = ({
  drawerState,
  setDrawerState,
  paidVideoData,
  setSuccess,
  creatorData,
  type,
}) => {
  const creator = type === "video" ? paidVideoData?.creator : creatorData;
  const { userData } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [selectedSubscription, setSelectedSubscription] = useState(null);

  const navigate = useNavigate();
  const stripe = useStripe();
  const elements = useElements();

  const handlePackageSelect = (pkg) => {
    setSelectedSubscription(pkg);
  };
  const [fullName, setFullName] = useState(userData?.firstName || "");
  const [email, setEmail] = useState(userData?.email || "");
  const [savedCards, setSavedCards] = useState([]);
  const [selectedCardId, setSelectedCardId] = useState(null);
  const [addingNew, setAddingNew] = useState(false);

  const [subscriptionDetails, setSubscriptionDetails] = useState(null);

  const [loading, setLoading] = useState(false);
  const [errorState, setErrorState] = useState({
    error: false,
    message: "",
  });

  const fetchSavedCards = async () => {
    try {
      const { data } = await axiosInstance.get(`/payments/getUserInfo`);
      const cards = data.paymentMethods || [];
      setSavedCards(cards);
      setAddingNew(cards.length === 0);
    } catch (err) {
      setErrorState({ error: true, message: "Failed to fetch cards." });
    }
  };

  useEffect(() => {
    fetchSavedCards();
  }, []);

  const handleSubscription = async () => {
    setErrorState({ error: false, message: "" });
    if (!stripe || !elements) return;

    try {
      setLoading(true);
      let paymentMethodId = selectedCardId;

      if (addingNew) {
        const { data: setupIntentRes } = await axiosInstance.post(
          "/payments/createPaymentIntent"
        );

        const result = await stripe.confirmCardSetup(
          setupIntentRes.clientSecret,
          {
            payment_method: {
              card: elements.getElement(CardNumberElement),
            },
          }
        );

        if (result.error) {
          setErrorState({ error: true, message: result.error.message });
          return;
        }

        paymentMethodId = result.setupIntent.payment_method;
      }

      if (type === "creator") {
        await subscribeCreator(
          creator?.creatorProfile?.id,
          selectedSubscription.id,
          paymentMethodId
        );
        setSuccess(true);
        dispatch(getCreatorsSubscribed());
        dispatch(getAllCreators());
        dispatch(getUserById(userData.id));
        navigate(`/profile/${creator.id}`);
      } else {
        const response = await subscribeToContent(
          paidVideoData?.id,
          paymentMethodId
        );
        if (response) {
          setSuccess(true);
          dispatch(getAllPosts());
          navigate(`/profile/${creator.id}`);
        }
      }
    } catch (error) {
      setErrorState({ error: true, message: error.message });
    } finally {
      setLoading(false);
      setDrawerState(false);
    }
  };

  const stripeStyle = {
    base: {
      fontSize: "16px",
      color: "#333",
      "::placeholder": {
        color: "#999",
      },
    },
    invalid: {
      color: "#e5424d",
    },
  };

  useEffect(() => {
    if (type !== "video" && creatorData?.subscriptions?.length > 0) {
      setSelectedSubscription(creatorData.subscriptions[0]);
    }
  }, [creatorData?.subscriptions]);

  const getSubscription = async () => {
    if (type === "creator" && drawerState) {
      const response = await getSubscriptionOfUser(creator?.creatorProfile?.id);

      setSubscriptionDetails(response);
    }
  };

  useEffect(() => {
    getSubscription();
  }, [drawerState]);

  return (
    <Drawer
      anchor={"right"}
      open={drawerState}
      sx={{
        "& .MuiDrawer-paper": {
          width: "75%",
          border: "1px solid #000",
          backgroundColor: "#fff",
        },
      }}
      onClose={() => setDrawerState(false)}
    >
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {/* Snackbar */}
      <ErrorSnackbar
        error={errorState.error}
        handleCloseError={() => setErrorState({ error: false, message: "" })}
        errorMsg={errorState.message}
      />
      <Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 4,
            py: 2,
            borderBottom: "1px solid #000",
          }}
        >
          <Typography
            sx={{
              fontSize: "23px",
              fontFamily: "Inter-SemiBold",
              color: colors.textColor,
            }}
          >
            Exercise View
          </Typography>
          <Stack
            direction="row"
            alignItems={"center"}
            sx={{
              width: "50%",
              gap: 2,
              justifyContent: "flex-end",
            }}
          >
            <SecondaryBtn
              onClick={() => setDrawerState(false)}
              text="Close"
              Icon={Close}
              noMb
              noMt
              width="20%"
            />
            <SecondaryBtn
              onClick={handleSubscription}
              text="Subscribe"
              Icon={East}
              noMb
              noMt
              width="30%"
              filled
            />
          </Stack>
        </Box>

        <Box sx={{ m: 3 }}>
          <Stack
            direction="row"
            sx={{
              alignItems: "center",
              gap: 4,
            }}
          >
            <img
              src={creator?.avatar || require("../../assets/images/user.jpg")}
              style={{
                height: "200px",
                width: "300px",
                objectFit: "cover",
                // border: "1px solid #000",
              }}
              alt="avatar"
            />

            <Stack direction="column">
              <Typography
                sx={{
                  fontFamily: "Inter-SemiBold",
                  fontSize: "32px",
                  fontWeight: "600",
                }}
              >
                {creator?.firstName + " " + creator?.lastName}
              </Typography>
              <Typography
                sx={{
                  mt: 1,
                  color: "#00000080",
                  fontSize: "18px",
                  fontFamily: "Inter-Regular",
                  overflow: "hidden",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: 5,
                  textOverflow: "ellipsis",
                }}
              >
                {creator?.bio}
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Inter-Medium",
                  color: colors.textColor,
                  fontWeight: "400",
                  textTransform: "uppercase",
                  letterSpacing: 2,
                  mt: 3,
                }}
              >
                Pay
                <Typography
                  component="span"
                  sx={{
                    fontFamily: "Inter-SemiBold",
                    color: colors.primary,
                    textTransform: "uppercase",
                    letterSpacing: 2,
                  }}
                >
                  {type === "video"
                    ? ` $${
                        paidVideoData?.discount
                          ? paidVideoData.price *
                            (1 - paidVideoData.discount / 100)
                          : paidVideoData.price
                      }`
                    : ` $${selectedSubscription?.price}`}{" "}
                </Typography>
                {type === "video"
                  ? "to unlock this video only"
                  : `to subscribe to this creator's `}
                {type !== "video" && selectedSubscription?.packageName && (
                  <Typography
                    component="span"
                    sx={{
                      fontFamily: "Inter-SemiBold",
                      color: colors.primary,
                      textTransform: "uppercase",
                      letterSpacing: 2,
                    }}
                  >
                    {selectedSubscription.packageName} plan
                  </Typography>
                )}
              </Typography>
              {type !== "video" && creatorData?.subscriptions?.length > 0 && (
                <Stack
                  direction={"row"}
                  spacing={2}
                  useFlexGap
                  flexWrap="wrap"
                  sx={{
                    mb: 3,
                    justifyContent: { xs: "center", sm: "flex-start" },
                  }}
                >
                  {creatorData.subscriptions.map((pkg, idx) => {
                    const isSelected =
                      selectedSubscription?.packageName === pkg.packageName;
                    return (
                      <Box
                        key={idx}
                        onClick={() => handlePackageSelect(pkg)}
                        sx={{
                          border: isSelected
                            ? "2px solid #FC0108"
                            : "1px solid #ccc",
                          borderRadius: 2,
                          p: 2,
                          cursor: "pointer",
                          backgroundColor: isSelected ? "#FFF5F5" : "#fff",
                          width: { xs: "100%", sm: "230px" },
                          transition: "all 0.3s ease",
                          position: "relative",
                        }}
                      >
                        {isSelected && (
                          <Typography
                            variant="caption"
                            sx={{
                              position: "absolute",
                              top: 4,
                              right: 8,
                              color: "#FC0108",
                              fontWeight: "bold",
                              fontSize: "12px",
                            }}
                          >
                            Selected
                          </Typography>
                        )}
                        <Typography sx={{ fontWeight: 600 }}>
                          {pkg.packageName}
                        </Typography>
                        <Typography sx={{ color: colors.primary, mt: 0.5 }}>
                          ${pkg.price}
                        </Typography>
                        <Typography
                          sx={{ fontSize: "14px", color: "#666", mt: 1 }}
                        >
                          {pkg.description}
                        </Typography>
                      </Box>
                    );
                  })}
                </Stack>
              )}
            </Stack>
          </Stack>

          <Grid2 container spacing={2} sx={{ mt: 4 }}>
            <Grid2 item size={{ xs: 12, md: 6 }}>
              <CustomInputLabel text="Full Name" required />
              <CustomInput
                value={fullName}
                setValue={setFullName}
                Icon={PersonOutline}
                placeholder="e.g. John Doe"
              />
            </Grid2>
            <Grid2 item size={{ xs: 12, md: 6 }}>
              <CustomInputLabel text="Email" required />
              <CustomInput
                value={email}
                setValue={setEmail}
                Icon={EmailOutlined}
                placeholder="e.g. john@gmail.com"
              />
            </Grid2>
          </Grid2>
          <Grid2 container spacing={2}>
            <Typography sx={{ mt: 3, fontWeight: 600 }}>
              Payment Method
            </Typography>
            {!addingNew && savedCards.length > 0 && (
              <Stack spacing={2} mb={3}>
                {savedCards.map((card) => (
                  <Box
                    key={card.id}
                    onClick={() => setSelectedCardId(card.id)}
                    sx={{
                      border:
                        selectedCardId === card.id
                          ? "2px solid #FC0108"
                          : "1px solid #ccc",
                      borderRadius: 2,
                      p: 2,
                      cursor: "pointer",
                      backgroundColor:
                        selectedCardId === card.id ? "#FFF5F5" : "#fff",
                    }}
                  >
                    <Typography fontWeight="bold">
                      **** **** **** {card.card.last4}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {card.card.brand} — Exp {card.card.exp_month}/
                      {card.card.exp_year}
                    </Typography>
                  </Box>
                ))}
                <SecondaryBtn
                  text="Add New Card"
                  width="200px"
                  noIcon
                  onClick={() => {
                    setAddingNew(true);
                    setSelectedCardId(null);
                  }}
                />
              </Stack>
            )}

            {addingNew && (
              <Box mt={3}>
                <Typography variant="body2" mb={1}>
                  Enter your card info
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    width: 500,
                  }}
                >
                  <Box sx={{ border: "1px solid #ccc", p: 2, borderRadius: 2 }}>
                    <Typography variant="caption">Card Number</Typography>
                    <CardNumberElement options={{ style: stripeStyle }} />
                  </Box>

                  <Box sx={{ display: "flex", gap: 2 }}>
                    <Box
                      sx={{
                        border: "1px solid #ccc",
                        p: 2,
                        borderRadius: 2,
                        flex: 1,
                      }}
                    >
                      <Typography variant="caption">Expiry</Typography>
                      <CardExpiryElement options={{ style: stripeStyle }} />
                    </Box>
                    <Box
                      sx={{
                        border: "1px solid #ccc",
                        p: 2,
                        borderRadius: 2,
                        flex: 1,
                      }}
                    >
                      <Typography variant="caption">CVC</Typography>
                      <CardCvcElement options={{ style: stripeStyle }} />
                    </Box>
                  </Box>
                </Box>

                {savedCards.length > 0 && (
                  <SecondaryBtn
                    text="Back to Saved Cards"
                    width="200px"
                    noIcon
                    onClick={() => {
                      setAddingNew(false);
                      setSelectedCardId(null);
                    }}
                  />
                )}
              </Box>
            )}
          </Grid2>
        </Box>
      </Box>
    </Drawer>
  );
};

export default SubscribeVideoDrawer;
